const TimelineBackground50 = 'url(/images/TimelineBackground50.svg)';
const TimelineBackground25 = 'url(/images/TimelineBackground25.svg)';
const TimelineBackground12 = 'url(/images/TimelineBackground12.svg)';
const TimelineBackground6 = 'url(/images/TimelineBackground6.svg)';
const TimelineBackground3 = 'url(/images/TimelineBackground3.svg)';

const timelineBackgrounds = {
    "50": TimelineBackground50,
    "25": TimelineBackground25,
    "12": TimelineBackground12,
    "6": TimelineBackground6,
    "3": TimelineBackground3,
}
const widths = {
    "50": 1200,
    "25": 600,
    "12": 288,
    "6": 144,
    "3": 72,
}

export {
    timelineBackgrounds as default,
    TimelineBackground50,
    TimelineBackground25,
    TimelineBackground12,
    TimelineBackground6,
    TimelineBackground3,
    widths
}